export default __webpack_public_path__ + "static/media/checkbox1.1af17caf.svg";